import { render, staticRenderFns } from "./loading-layer.vue?vue&type=template&id=a52514a0"
import script from "./loading-layer.vue?vue&type=script&lang=js"
export * from "./loading-layer.vue?vue&type=script&lang=js"
import style0 from "./loading-layer.vue?vue&type=style&index=0&id=a52514a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports